import { useMemo } from 'react';

import { type CustomAttributeType } from 'hb-react/frontoffice/apps/Mentoring/types';
import { type CustomAttributesForm } from 'hb-react/types';

export const useHydrateCustomAttributes = (
  customAttributesSchema: Array<
    Pick<CustomAttributeType, 'config' | 'display_name' | 'id'>
  >,
  attributes: Array<CustomAttributesForm>,
) =>
  useMemo(() => {
    if (!attributes || !customAttributesSchema) {
      return [];
    }

    return customAttributesSchema
      .map((attribute) => {
        const profileAttribute = attributes.find(
          (profileAttribute) =>
            profileAttribute.customizable_attribute_id === attribute.id,
        );

        return {
          ...attribute,
          ...profileAttribute,
          display_value: profileAttribute?.display_value ?? '-',
        };
      })
      .filter((attribute) => attribute.config?.is_displayed_in_mentoring_card);
  }, [customAttributesSchema, attributes]);
